import { System } from '@ecs/System';
import { PlayerInput } from '@components/PlayerInput';
import { TargetHighlight } from '@components/TargetHighlight';
import { Position } from '@components/Position';

export class TargetingLogicSystem extends System {
  update(_deltaTime: number): void {
    // Clear all highlights first
    const allTargets = this.getEntitiesWithComponents(TargetHighlight);
    for (const target of allTargets) {
      const highlight = target.getComponent(TargetHighlight)!;
      highlight.isTargeted = false;
    }
    
    // Find all player inputs and set highlights for their targets
    const playerInputs = this.getEntitiesWithComponents(PlayerInput, Position);
    
    for (const playerEntity of playerInputs) {
      const input = playerEntity.getComponent(PlayerInput)!;
      
      if (input.targetEntity) {
        const targetEntity = this.world.getEntity(input.targetEntity);
        if (targetEntity) {
          const highlight = targetEntity.getComponent(TargetHighlight);
          if (highlight) {
            highlight.isTargeted = true;
          }
        }
      }
    }
  }
}